import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = {
  class: "staff-top-nav",
  "aria-label": "메뉴"
}
const _hoisted_4 = { class: "header-right" }
const _hoisted_5 = { class: "impersonate-info" }
const _hoisted_6 = { class: "from-user" }
const _hoisted_7 = { class: "to-user" }
const _hoisted_8 = {
  key: 1,
  class: "user-info"
}
const _hoisted_9 = { class: "header-role-badge" }
const _hoisted_10 = { class: "user-name" }
const _hoisted_11 = { class: "impersonate-menu-info" }
const _hoisted_12 = { class: "info-text" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "staff-main" }
const _hoisted_15 = { class: "exit-header-title" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import UserProfileDialog from '@/components/common/UserProfileDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffLayout',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const exitDialog = ref(false);
const profileDialog = ref(false);

const navItems = [
  { title: '고객관리', to: '/member' },
  { title: '시설검색', to: '/facility' },
];

const currentUser = computed(() => store.getters.currentUser);
const isImpersonating = computed(() => store.getters.isImpersonating);
const originalUser = computed(() => store.getters.originalUser);

const isActive = (to: string) => {
  if (to === '/member') {
    return route.path === '/' || route.path === '/member' || route.path.startsWith('/member/');
  }
  return route.path === to || route.path.startsWith(`${to}/`);
};

const goMember = () => {
  router.push('/member');
};

const handleLogout = () => {
  store.dispatch('logout');
  // 진행 중 API 실패 스낵바가 덮어쓰지 않도록 로그인으로 즉시 이동
  window.location.href = '/login';
};

const exitImpersonation = () => {
  exitDialog.value = true;
};

const confirmExit = async () => {
  await store.dispatch('exitImpersonation');
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "staff-layout" }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "app-brand app-brand-btn",
            onClick: goMember
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "app-title" }, "CAION", -1),
            _createElementVNode("span", { class: "app-tagline" }, "장기요양 통합관리", -1)
          ]))]),
          _createElementVNode("nav", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createVNode(_component_router_link, {
                key: item.to,
                to: item.to,
                class: _normalizeClass(["staff-nav-link", { active: isActive(item.to) }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (isImpersonating.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "impersonate-indicator",
                onClick: exitImpersonation
              }, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "impersonate-icon"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-incognito", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(originalUser.value?.name), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "arrow" }, "→", -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(currentUser.value?.name), 1)
                ]),
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "exit-icon"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-close-circle", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!isImpersonating.value && currentUser.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(currentUser.value.roleName), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(currentUser.value.name) + "님", 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_menu, null, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({
                icon: "",
                size: "small",
                variant: "text",
                color: "white"
              }, props), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-account-circle", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, { density: "compact" }, {
                default: _withCtx(() => [
                  (isImpersonating.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_list_item, { class: "impersonate-menu-item" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "deep-purple"
                              }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                  _createTextVNode("mdi-incognito", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_12, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "접속 중인 계정", -1)),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(currentUser.value?.name), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, {
                          onClick: exitImpersonation,
                          class: "exit-menu-item"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              color: "error"
                            }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("mdi-arrow-left-circle", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "text-error" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(originalUser.value?.name) + "(으)로 복귀", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!isImpersonating.value)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (profileDialog.value = true))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode("mdi-account-cog-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("내 정보", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!isImpersonating.value)
                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 2 }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, { onClick: handleLogout }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-logout", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("로그아웃", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(UserProfileDialog, {
        modelValue: profileDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileDialog).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: exitDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((exitDialog).value = $event)),
        "max-width": "380px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "exit-dialog" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "exit-header" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_v_icon, {
                      class: "mr-2",
                      color: "warning"
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("mdi-arrow-left-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[18] || (_cache[18] = _createTextVNode(" 권한 복귀 ", -1))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "exit-close",
                    "aria-label": "닫기",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (exitDialog.value = false))
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "exit-body" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(originalUser.value?.name), 1),
                    _cache[20] || (_cache[20] = _createTextVNode(" 계정으로 돌아가시겠습니까?", -1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "exit-actions" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    class: "btn-cancel",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (exitDialog.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("취소", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-confirm",
                    onClick: confirmExit
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode("복귀하기", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 3
  }))
}
}

})